var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVipBadgeActiveIcon = function SvgVipBadgeActiveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 16,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 16,
    x: 0.5,
    fill: "#CE4084",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF5E6",
    d: "M11.43 12 8.41 5h1.75l2.64 6.2h-1.03L14.45 5h1.61l-3.03 7h-1.6Zm5.215 0V5h1.62v7h-1.62Zm3.28 0V5h3.03c.627 0 1.167.103 1.62.31.454.2.804.49 1.05.87.247.38.37.833.37 1.36 0 .52-.123.97-.37 1.35-.246.38-.596.673-1.05.88-.453.2-.993.3-1.62.3h-2.13l.72-.73V12h-1.62Zm1.62-2.48-.72-.77h2.04c.5 0 .874-.107 1.12-.32.247-.213.37-.51.37-.89 0-.387-.123-.687-.37-.9-.246-.213-.62-.32-1.12-.32h-2.04l.72-.77v3.97Z"
  })));
};
export default SvgVipBadgeActiveIcon;